import { withTranslation } from "next-i18next";
import Image from "@components/core/Image";

function DrawerPostReturnedSubscriptionWaiting({ t }) {
  return (
    <div className="d-flex flex-column align-items-center bg-white py-4 px-3 text-center flex-grow-1">
      <h5 className="pt-2 px-4 mb-2">
        {t('common:drawer.modal_post_returned.your_closet_has_been_picked_up_by_the_carrier')}
      </h5>
      <p className="mb-0 px-3 text-gray">
        {t('common:drawer.modal_post_returned.your_return_parcel_has_been_scanned')}
      </p>
      <Image
        src="deliveryLightNeon"
        alt="skate"
        className="my-4"
        width={140}
      />
      <p className="mb-0 px-3 text-gray">
        {t('common:drawer.modal_post_returned.unsubscribe_effective_after_return')}
      </p>
    </div>
  );
}

export default withTranslation("common")(DrawerPostReturnedSubscriptionWaiting);
